<!-- header part start-->
<div class="container-fluid">
    <div style=" display: inline;block-size: 10%;">
      <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 10px;">
          <div class="col-md-6 col-sm-6" style="display: inline-block;padding-left: 6px; ">
              <h2 class="ng-binding header lblHeader newHeader" style="font-size: 25px;">
                Rejection Cause Analysis	
              </h2>
          </div>
          <div class="col-md-6 col-sm-6" style="display: inline-block; padding: 0px;text-align: right; padding-right: 5px;padding-top: 10px;">
            <span class="search" *ngIf="dataSource.data.length > 0">
              <span class="fa fa-search" style="padding-left: 13px; font-size: 14px;
              position: absolute;top: 18px;color: #999;"></span>
                <input class="form-control formCtlFltr brdrRadius3" ng-model="search.term" placeholder="Search" matInput
                (keyup)="applyFilter($event)" #input
                style="text-align: left; background-color: white !important;  display: inline-block; padding-left: 35px !important; font-size: 13px; box-shadow: none; width: 45% !important; height: 31px !important;"
                type="text">
    
            </span>
            <span *ngIf="dataSource.data.length > 0" (click)="exportToExcelActivities()" class="orangeButton"
              style="margin-left: 10px; cursor: pointer;" title="Export to Excel">
              <span>
                <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
              </span>
            </span>
    
              <div style="display: inline-block; padding: 0px;" title="Back to production Dashboard">
                  <span class="darkBlueButton"
                      style="font-size: 13px; display: inline-block; padding: 4px 10px; margin-left: 10px;"
                      (click)="backBtn()">
                      <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Production
                  </span>
              </div>
  
          </div>
      </div>
    </div>
  
    <!-- filter -->
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 0px;">
      <div class="col-md-8 col-sm-8" style="display: inline-block;padding-left: 0px; ">
        <div class="col-md-12 col-12 col-sm-12"style="display: inline-block;padding-left: 11px;  " >
            <div style="display:inline-block ;">
              <div style="display: inline-block; padding-left: 8px;" >
                  <label  style="font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
                      for="sel1">Month : 
                  </label>
              </div>
              <div style="display: inline-block;margin-left: 10px;">
                  <select  class="form-control bgwhite formCtlFltr" style="box-shadow: none;width: 100px;cursor: pointer; font-size: 13px;" [(ngModel)]="monthDisplay" 
                  (change) ="trasYearChange()">
                  <option *ngFor="let i of months;">{{i.display}}</option>
                </select>
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- close filter -->
  
    <!-- table - datalist -->
    <div class="col-md-12 co-sm-12 col-xs-12">
      <div class="col-md-8 co-sm-8 col-xs-8" style="overflow: hidden; padding-left: 0px !important; text-overflow: ellipsis; white-space: nowrap; padding-top: 15px; padding-right: 14px;border-radius: 10px;" *ngIf="dataSource.data.length > 0" #csttable>
        <table mat-table [dataSource]="dataSource" matSort style="border-radius: 3px; padding-left: 16px !important; padding: 0px;width: 65%;">
          <ng-container matColumnDef="RejectionType">
            <th class="header header-Table fntSz" mat-header-cell *matHeaderCellDef  mat-sort-header style="padding-top: 12px;width: 12%; padding-bottom: 8px;">
              <label style="font-size: 13px;">Rejection Type</label>
            </th>
            <td mat-cell *matCellDef="let element" style="width: 10%;"> {{element.RejectionType}} </td>
          </ng-container>
  
          <ng-container matColumnDef="JobsImpected">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; cursor: pointer; padding-left: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Jobs Impacted</label>
            </th>
            <td  mat-cell *matCellDef="let element" style="width: 0%;">
                <div style="text-align: right; padding-right: 12px;">
                  {{element.JobsImpacted ? element.JobsImpacted : 0 }}  </div>
            </td>
          </ng-container>
  
  
          <ng-container matColumnDef="Share">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
                style="text-align: right; font-size: 13px; padding-right: 0px;cursor: pointer; padding-left: 5px;">
                <label style="cursor: pointer;font-size: 13px;">Share</label>
            </th>
            <td  mat-cell *matCellDef="let element" style="width: 0%;">
                <div style="text-align: right; padding-right: 10px;">
                  {{element.Share }} %</div>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
  
  
  
          <!-- Angular 8 pagination -->
          <mat-paginator style="width: 65%; padding-right: 3px;"
                [pageSizeOptions]="[10, 15]" showFirstLastButtons>
          </mat-paginator>
      </div>
  
      <div class="col-md-4 co-sm-4 col-xs-4"></div>
    </div>
      <!-- close table - datalist -->
  
    <div *ngIf="dataSource.data.length == 0">
        <div style="margin:15px" class="nrf brdrRadius3">No records found.</div>
    </div>
      
  </div>
  <ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

  </ngx-spinner>
    